<template>
  <div class="modal-tip">
    <van-overlay :show="show">
      <div class="wrap">
        <div class="tip">
          <div class="content">
            <div class="head">{{ titleText }}</div>
            <div class="first">
              <slot name="content"></slot>
            </div>
          </div>
          <div class="footer" :class="{ single: !isShowCancelBtn }">
            <div v-if="isShowCancelBtn" class="btn disagree" @click="cancel">
              {{ cancelText }}
            </div>
            <div class="btn agree" @click="confirm">{{ confirmText }}</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    titleText: {
      type: String,
      default: '温馨提示'
    },
    isShowCancelBtn: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    }
  },
  data() {
    return {}
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.modal-tip {
  .wrap {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    > .tip {
      text-align: center;
      width: 300px;
      background: #ffffff;
      border-radius: 14px;
      > .content {
        padding: 0 20px;
        > .head {
          font-size: 17px;
          font-weight: 500;
          color: #1a1a1a;
          margin-top: 15px;
        }
        > .first {
          font-size: 15px;
          font-weight: 400;
          color: #1a1a1a;
          margin-top: 18px;
          text-align: left;
          max-height: 500px;
          overflow-y: scroll;
        }
      }
      > .footer {
        display: flex;
        align-items: center;
        margin-top: 15px;
        padding: 0 20px 25px;
        .btn {
          flex: 1;
          height: 40px;
          border-radius: 20px;
          font-size: 16px;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          &.disagree {
            border: 1px solid #ff3934;
            background: #fff3f3;
            color: #ff3934;
            margin-right: 20px;
          }
          &.agree {
            background: #ff3934;
            color: #fff;
          }
        }
        &.single {
          .btn {
            width: 150px;
            flex: none;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
